'use client';

import _defineProperty from "/codebuild/output/src3339/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src3339/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["size", "style"],
  _excluded2 = ["indeterminate"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { rem } from '../../core/utils/units-converters/rem.mjs';
import 'react';
import '@mantine/hooks';
import 'clsx';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import '../../core/Box/Box.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
function CheckIcon(_ref) {
  var size = _ref.size,
    style = _ref.style,
    others = _objectWithoutProperties(_ref, _excluded);
  var _style = size !== void 0 ? _objectSpread({
    width: rem(size),
    height: rem(size)
  }, style) : style;
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: _style,
    "aria-hidden": true
  }, others), {}, {
    children: /* @__PURE__ */jsx("path", {
      d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
      fill: "currentColor",
      fillRule: "evenodd",
      clipRule: "evenodd"
    })
  }));
}
function CheckboxIcon(_ref2) {
  var indeterminate = _ref2.indeterminate,
    others = _objectWithoutProperties(_ref2, _excluded2);
  if (indeterminate) {
    return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 6",
      "aria-hidden": true
    }, others), {}, {
      children: /* @__PURE__ */jsx("rect", {
        width: "32",
        height: "6",
        fill: "currentColor",
        rx: "3"
      })
    }));
  }
  return /* @__PURE__ */jsx(CheckIcon, _objectSpread({}, others));
}
export { CheckIcon, CheckboxIcon };